export default function uuidToUrl(uuid, videoEnabled, baseURL) {

    const format = videoEnabled ? 'video' : 'audio';
    return `${baseURL}/${format}/${uuid}`

}
